export enum STORAGE_KEYS {
  USER_LANGUAGE = 'userLanguage',
}
